import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSendABTestEmails } from '../../../mutation/ab-test';
import SendButton from 'containers/Mail/FormFields/SendButton';

const SubmitForm = ({ isCsvValid, totalRows }) => {
  const { reset } = useFormContext();

  const { isLoading, mutate } = useSendABTestEmails({ onSuccess: reset });

  const doSending = values => {
    const formData = new FormData();
    const {
      growthBookFeatureName,
      projectId,
      senderName,
      senderEmail,
      csvFiles,
      force_choose,
      scheduledTime: scheduled_time,
    } = values;
    formData.append('csv_file', csvFiles[0]);
    formData.append(
      'payload',
      JSON.stringify({
        feature_name: growthBookFeatureName,
        project_id: projectId,
        force_choose,
        scheduled_time,
        sender: {
          name: senderName,
          email: senderEmail,
        },
      }),
    );
    mutate(formData);
  };

  return (
    <SendButton
      disabled={!isCsvValid}
      isLoading={isLoading}
      totalRows={totalRows}
      onSend={doSending}
    />
  );
};

export default SubmitForm;
